const contentDivs = document.querySelectorAll('.page-content div[id]');
const linkList = document.getElementById('linkList');

let activeLink = null;

const links = Array.from(contentDivs).map((contentDiv, index) => {
    const id = contentDiv.getAttribute('id');
    const content = id.replace(/-/g, ' ');

    if (!contentDiv.closest('.gform_wrapper') && !contentDiv.closest('.cta-widget')) {
        const link = document.createElement('li');
        link.innerHTML = `<a href="#${id}">${content}</a>`;
        linkList.appendChild(link);

        // Set "active" class on the first link
        if (index === 0) {
            link.classList.add('active');
            activeLink = link;
        }

        return link;
    }
});

// Trigger the scroll event to initially set the first link as active
window.dispatchEvent(new Event('scroll'));

// Add a scroll event listener to track when contentDivs are in view
window.addEventListener('scroll', () => {
    const windowCenter = window.innerHeight / 3;

    // Find the first contentDiv in view
    let activeIndex = -1;
    contentDivs.forEach((contentDiv, index) => {
        const rect = contentDiv.getBoundingClientRect();
        if (rect.top <= windowCenter && rect.bottom >= windowCenter) {
            activeIndex = index;
        }
    });

    // Update the active link
    if (activeIndex !== -1) {
        const newActiveLink = links[activeIndex];
        if (newActiveLink) {
            if (newActiveLink !== activeLink) {
                if (activeLink) {
                    activeLink.classList.remove('active');
                }
                newActiveLink.classList.add('active');
                activeLink = newActiveLink;
            }
        }
    }
});

// Mobile open and close
(function ($) {
    'use strict';

    let $body = $(document.body);
    let $mobileSidebarMenu = $('#mobileSidebarMenu');
    let $linkList = $('#linkList');

    $body.on('click', '#mobileSidebarMenu', function () {
        $mobileSidebarMenu.toggleClass('open');
        $mobileSidebarMenu.next().toggleClass('open');
        $mobileSidebarMenu.parent().toggleClass('open');
    });

    // Close the menu when clicking outside the div
    $body.on('click', function (e) {
        if (
            !$mobileSidebarMenu.is(e.target) &&
            $mobileSidebarMenu.has(e.target).length === 0 &&
            !$linkList.is(e.target) &&
            $linkList.has(e.target).length === 0
        ) {
            $mobileSidebarMenu.removeClass('open');
            $mobileSidebarMenu.next().removeClass('open');
            $mobileSidebarMenu.parent().removeClass('open');
        }
    });

    $linkList.on('click', 'li', function () {
        $mobileSidebarMenu.removeClass('open');
        $mobileSidebarMenu.next().removeClass('open');
        $mobileSidebarMenu.parent().removeClass('open');
    });

}(jQuery));
//# sourceMappingURL=sidebar-headings.js.map
